import { client } from '../http';

// eslint-disable-next-line import/prefer-default-export
export async function updateSignupOfferingStatusChosen() {
  const response = await client.put('/api/choose-signup-offering');
  return response.data;
}
